require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-dmc-soft-surf-helmet.json") })
        }
      }, "path---reviews-dmc-soft-surf-helmet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-dmc-soft-surf-helmet!./.cache/json/reviews-dmc-soft-surf-helmet.json
// module id = 684
// module chunks = 231608221292675